<template>
  <div class="dilivery">
    <BtnBack class="back" />
    <BlockContacts />
  </div>
</template>
<script>
import BlockContacts from "@/components/home/BlockContacts.vue";
import BtnBack from "@/components/BtnBack.vue";
export default {
  name: "Contacts",
  components: {
    BlockContacts,
    BtnBack,
  },
};
</script>
<style lang="scss" scoped>
@media only screen and (max-width: 767px) {
  .back {
    margin-top: 2vh;
  }
}</style>
